import type {PotentialActivityEntityFragment as Participant} from 'nutshell-graphql-types';

import type {ParticipantWithCheckedValue} from './types';

export const getExternalAttendeesFromParticipants = (
    participants: Array<Participant>
): Array<ParticipantWithCheckedValue> => {
    return participants
        .filter((participant) => participant.type === 'activityExternalAttendees')
        .map((externalAttendee) => {
            return {
                ...externalAttendee,
                isChecked: true,
            };
        });
};
